export const poolMenus = {
  eth: {
    iearn: "yVault USD",
    busd: "yVault Curve",
    ethsnow: "eth2SNOW",
    fusd: "fUSD",
    crveth: "crvETH",
    yvault3: "yVault USD v3",
  },
  rin: {
    '3pool': '3Pool',
  },
  matic: {
    usdsnow: 'usdSNOW',
  },
  maticmum: {},
}
